module.exports = __webpack_public_path__ + "img/small_handle_with_sleeve.asm.28f81585.jpg";